import * as LookupService from '~/app/services/knowledgeBase/lookup.service';
import * as AssociationService from '~/app/services/knowledgeBase/association.service';
import * as CrudService from '~/app/services/knowledgeBase/crud.service';

export const ComponentSchemaService = {
  // Lookup methods
  getLookup: LookupService.getLookup,
  getLookupWithMeta: LookupService.getLookupWithMeta,
  getComponentClassesForAssetSubsystem:
    LookupService.getComponentClassesForAssetSubsystem,
  getComponentTypesForAssetSubsystemComponentClass:
    LookupService.getComponentTypesForAssetSubsystemComponentClass,

  // Association methods

  setComponentClassesForSubsystem:
    AssociationService.setComponentClassesForSubsystem,

  setSubsystemsForComponentClass:
    AssociationService.setSubsystemsForComponentClass,
  setSubsystemsForAssetType: AssociationService.setSubsystemsForAssetType,
  getSubsystemIdsForAssetType: AssociationService.getSubsystemIdsForAssetType,
  setAssetTypesForSubsystem: AssociationService.setAssetTypesForSubsystem,
  getAssetTypeIdsForSubsystem: AssociationService.getAssetTypeIdsForSubsystem,
  setComponentClassesForJunction:
    AssociationService.setComponentClassesForJunction,
  setComponentClassesForAssetSubsystemMapping:
    AssociationService.setComponentClassesForAssetSubsystemMapping,
  getComponentTypesForAssetSubsystemComponentClassMapping:
    AssociationService.getComponentTypesForAssetSubsystemComponentClassMapping,
  setComponentTypesForAssetSubsystemComponentClassMapping:
    AssociationService.setComponentTypesForAssetSubsystemComponentClassMapping,

  // CRUD methods
  uploadCsv: CrudService.uploadCsv,
  deleteRow: CrudService.deleteRow,
  saveRow: CrudService.saveRow,
};

// Re-export types for convenience
export type {
  EnrichedSubsystem,
  EnrichedComponentClass,
  SubsystemComponentMappingResponseDto,
  ExtendedSubsystemComponentMapping,
  ComponentTypeResponseDto,
} from '~/app/services/knowledgeBase/types';
